export const getEstimateReadTime = (wordCount: number): number => {
    // the average adult reads 200-250 words in one minute
    const readTime = Math.round(wordCount / 200);
    return readTime > 0 ? readTime : 1;
};

export const getEstimateReadTimeLabel = (wordCount: number): string => {
    return `${getEstimateReadTime(wordCount)} MIN READ`;
};
